import { render, staticRenderFns } from "./SpecialItemsNew.vue?vue&type=template&id=7554a2bb&"
import script from "./SpecialItemsNew.vue?vue&type=script&lang=js&"
export * from "./SpecialItemsNew.vue?vue&type=script&lang=js&"
import style0 from "./SpecialItemsNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports